import 'core-js/stable/array/includes';
import 'core-js/stable/object/assign';
import 'core-js/stable/promise';
import 'core-js/stable/dom-collections/for-each';
import 'core-js/stable/url-search-params';
import _SocialEmbed from './social-embed';

window['SocialEmbed'] = _SocialEmbed;

export const SocialEmbed = _SocialEmbed;
